var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shadow-box-wrapper"},[(_vm.icon)?_c('div',{staticClass:"icon-div"},[_c('ion-icon',{attrs:{"name":_vm.icon[0]}}),_vm._v(" "),(_vm.icon.length > 1)?_c('ion-icon',{staticClass:"minor-icon",attrs:{"name":_vm.icon[1]}}):_vm._e()],1):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1983c425","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/views/components/layouts/shadowBox.vue
// module id = 860
// module chunks = 0